module.exports = __webpack_public_path__ + "static/media/CenturyGothic.cca85f2b.woff";